import ComponentRegistry from "@/components/localization/ComponentRegistry"
import { mapState } from "vuex"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey"

export default {
    inject: {
        localizationContext: {
            default() {
                return {
                    providerKey:  null
                }
            }
        }
    },

    provide() {
        const localizationContext = {}
        Object.defineProperty(localizationContext, "providerKey", {
            enumerable: true,
            get: () => this.computedProviderKey
        })

        return {
            localizationContext,
        }

    },

    props: {
        groupId: {
            type: String,
        },

        providerKey: {
            type: String,
        },
    },

    data() {
        return {
            componentType: null,
        }
    },

    computed: {
        computedGroupId() {
            return this.groupId || this.sessionGroupId
        },

        computedProviderKey() {
            return DynamicProviderKey.extractProviderKey(this.providerKey || this.localizationContext?.providerKey || this.sessionProviderKey)
        },

        localized() {
            return !!this.component
        },

        ...mapState("session", {
            sessionGroupId: state => state.data.groupId,
            sessionProviderKey: state => state.data.dynamicProviderKey.providerKey
        }),

        component() {
            return ComponentRegistry.findComponent(this.componentType, this.computedGroupId, this.computedProviderKey)
        },
    },
}
